import { CheckCircle } from "lucide-react";
import { pluralize } from "common/utils/format/word";
import type { TransferEntry } from "../model/useTransfersUpload";

type UploadStatusDisplayProps = {
  entries: TransferEntry[];
  hasUploadingArtwork: boolean;
  uploadingCount: number;
};

export function UploadStatusDisplay({
  entries,
  hasUploadingArtwork,
  uploadingCount
}: UploadStatusDisplayProps) {
  // Total count includes all entries (both uploaded and from library)
  const totalCount = entries.length;

  let statusText = "Upload Artwork";
  if (hasUploadingArtwork) {
    statusText = `Uploading ${pluralize(uploadingCount, "image", "s")}...`;
  } else if (totalCount > 0) {
    statusText = `Uploaded ${pluralize(totalCount, "image", "s")}`;
  }

  return (
    <div className="flex items-center gap-2">
      {!hasUploadingArtwork && totalCount > 0 && <CheckCircle className="size-6 text-green-600" />}
      <h2 className="text-lg font-semibold text-gray-900">{statusText}</h2>
    </div>
  );
}
